﻿import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export const initSocket = (token: string) => {
  socket?.disconnect();
  socket = io('/', { auth: { token } });
  socket.on('connect', () => console.log('Socket connected'));
  return socket;
};

export const updateSocketToken = (token: string) => {
  if (!socket) return initSocket(token);
  socket.auth = { token };
  if (!socket.connected) socket.connect();
  return socket;
};

export const disconnectSocket = () => {
  socket?.removeAllListeners();
  socket?.disconnect();
  socket = null;
};

export const getSocket = () => socket;
